import $ from 'jquery';

App.registerBehavior('TextFieldKeyupChange', function (appSettings, settingsKey) {
  const settings = 'object' === typeof appSettings[ settingsKey ] && appSettings[ settingsKey ] || {
    selector: ''
  };
  const selector = 'string' === typeof settings['selector'] && settings['selector'] || '';
  if (selector.length) {
    $(selector).once('TextFieldKeyupChangeBehavior').each(function () {
      const $field = $(this);
      let fieldValue = $field.val();
      let typingTimer;
      const typingInterval = 400; // ms
      $field.on('keyup', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function () {
          if ($field.val() !== fieldValue) {
            fieldValue = $field.val();
            $field.triggerHandler('change');
          }
        }, typingInterval);
      });
      $field.on('keydown', function () {
        clearTimeout(typingTimer);
      });
    });
  }
}, Util.lastOf(document.getElementsByTagName('script')).src);